import { render } from "./TextLocalize.vue?vue&type=template&id=3ebf06c0"
import script from "./TextLocalize.vue?vue&type=script&lang=js"
export * from "./TextLocalize.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__